import { type ScreenViewEvent } from '@stitch-fix/event-reporter';
import { type ComponentType } from 'react';
import { type NavProps } from '../../../../components/OnboardingVision/Nav';
import { type StepWrapperProps } from '../../../../components/OnboardingVision/StepWrapper';
import { anchor } from './flows/anchor';
import { nu } from './flows/nu';
import { type BusinessLine } from '../../../../types/definitions/vendor/graphql-schema.d';

const flowIds = ['nu', 'anchor'] as const;

export type FlowId = (typeof flowIds)[number];

export const defaultFlow: FlowId = 'nu';

export type StepComponentProps = {
  showContextualOnboarding: boolean;
};

export type Step = {
  step: string;
  Component: ComponentType<StepComponentProps>;
  bgColor?: StepWrapperProps['bgColor'];
  navBgColor?: NavProps['bgColor'];
  hideNav?: boolean;
  showNavTitle?: boolean;
  screenViewEvent: Pick<ScreenViewEvent, 'name' | 'content_id'>;
  gutter?: StepWrapperProps['gutter'];
  restrictedBusinessLines?: BusinessLine;
};

export const flows: Record<FlowId, Step[]> = {
  nu,
  anchor,
};
